if (!customElements.get("td-best-sellers")) {
  class TdBestSellers extends HTMLElement {
    constructor() {
      super();
      this.checkbox = null;
    }

    connectedCallback() {
      this.checkbox = this.querySelector("#td-bs__toggle-checkbox");
      if (this.checkbox) {
        this.checkbox.addEventListener("change", this.toggleCollectionClass.bind(this));
      }
    }

    toggleCollectionClass() {
      if (this.checkbox.checked) {
        this.classList.add("td-bs__collection--1");
        this.classList.remove("td-bs__collection--2");
      } else {
        this.classList.add("td-bs__collection--2");
        this.classList.remove("td-bs__collection--1");
      }
    }
  }

  customElements.define("td-best-sellers", TdBestSellers);
}
